import { SxProps } from '@mui/system';

export const loadingContainerStyles: SxProps = {
  width: '100vw',
  height: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
